import { AxiosResponse } from 'axios';
import { IMeetingDto, IMeetingsForUsersResponse, IWorkCalendarDay, TConferenceType } from '../../types';
import { Service } from 'typedi';
import { axios } from '../axios';
import { ShowNotification } from '../ShowNotification';

interface IGetAllMeetingsArgs {
  startIntervalDate: string;
  endIntervalDate: string;
  userIds?: number[];
  conferenceRoom?: TConferenceType;
  conferenceRooms?: TConferenceType;
  splitByUserId?: boolean;
  requestMeeting?: 'ALL' | 'RELEX_MEETING' | 'USER_MEETING';
}

@Service()
export class CalendarRequest {
  @ShowNotification()
  getAllMeetings(body: IGetAllMeetingsArgs): Promise<AxiosResponse<IMeetingsForUsersResponse | IMeetingDto[]>> {
    return axios.post(`meetings/filter`, body);
  }

  @ShowNotification()
  getAllRoomsMeetings(body: IGetAllMeetingsArgs): Promise<AxiosResponse<IMeetingsForUsersResponse | IMeetingDto[]>> {
    return axios.post(`meetings/all-conference-rooms`, body);
  }

  @ShowNotification()
  getWorkCalendar(startDate: string, endDate:string): Promise<AxiosResponse<IWorkCalendarDay[]>> {
    return axios.get(`work-calendar?startDate=${startDate}&endDate=${endDate}`);
  }
}
